"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogType = void 0;
var LogType;
(function (LogType) {
    LogType["TwilioSms"] = "twilio-sms";
})(LogType = exports.LogType || (exports.LogType = {}));
//# sourceMappingURL=log.js.map